module.exports = require("@pb/kit-component-popups");